import React, { useState, useCallback, useMemo, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'antd';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import queryString from 'query-string';

import request from 'utils/request';
import Pficon from 'components/Pficon';
import { getSupportedMedia } from 'components/FileUpload/utils';
import messages from 'containers/TemplatePreviewPage/TemplateFlows/ComplexFlow/messages';

import UploadModal from './UploadModal';

function UploadMedia(props) {
  const {
    supportedMediaTypes,
    mediaValue = {},
    onChangeMedia,
    altText = '',
  } = props;

  const [modalIsVisible, setModalIsVisible] = useState(false);
  const supportedMedia = useMemo(
    () => getSupportedMedia(supportedMediaTypes),
    [supportedMediaTypes],
  );

  const onRemoveMediaFromServer = useCallback((media) => {
    if (media && media.url) {
      const qs = queryString.stringify({
        mediaUrl: media.url,
        type: media.type,
      });
      request(`/api/v3/survey-templates/media?${qs}`, {
        method: 'DELETE',
      });
    }
  }, []);

  const onRemoveMedia = useCallback(() => {
    onChangeMedia({});
    onRemoveMediaFromServer(mediaValue);
  }, [onChangeMedia, onRemoveMediaFromServer, mediaValue]);

  const showModal = useCallback(() => {
    setModalIsVisible(true);
  }, []);

  const closeModal = useCallback(() => {
    setModalIsVisible(false);
  }, []);

  return (
    <Fragment>
      {Boolean(mediaValue.url) && (
        <div
          className={classNames(
            'background-grey-1',
            'border-radius-level-1',
            'text-align-center',
            'padding-vertical-xxs',
            'position-relative',
            'flex',
            'flex-justify-center',
            'border-grey-5',
          )}
          style={{ width: 125, height: 48 }}
        >
          <img
            src={mediaValue.thumbnail}
            alt={altText}
            className="h-max-full"
            style={{ maxWidth: '65%' }}
          />
          <button
            type="button"
            className="position-absolute position-top-right cursor-pointer margin-right-xxs margin-top-xxs"
            onClick={onRemoveMedia}
          >
            <Pficon
              type="close"
              className="color-grey-10 color-grey-8-hover transition-normal"
            />
          </button>
        </div>
      )}
      {!mediaValue.url && (
        <Button
          onClick={showModal}
          className="border-radius-level-1 padding-vertical-none shadow-none border-grey-5 border-blue-5-hover"
          style={{
            height: '48px',
            lineHeight: '48px',
            width: 125,
          }}
        >
          Upload media
        </Button>
      )}

      <UploadModal
        visible={modalIsVisible}
        title={<FormattedMessage {...messages.uploadMedia} />}
        hideModal={closeModal}
        mask={false}
        saveMedia={onChangeMedia}
        removeMedia={onRemoveMediaFromServer}
        supportedMedia={supportedMedia}
      />
    </Fragment>
  );
}

UploadMedia.propTypes = {
  supportedMediaTypes: PropTypes.array,
  mediaValue: PropTypes.object,
  altText: PropTypes.string,
  onChangeMedia: PropTypes.func,
};

export default UploadMedia;
